import {Box, LinearProgress, Typography} from "@mui/material";
import {Spacer} from "../../../common";
import React from "react";

export default function LimitBar({value, max, name}: { value: number, max: number, name: string }) {
  const percent: number = value/max * 100;

  return (
    <Box>
      <Typography variant="body1">{name.charAt(0).toUpperCase() + name.slice(1)}</Typography>
      <LinearProgress variant="determinate" value={percent}/>
      <Typography variant="body2" sx={{color: "grey"}}>Using {value} {name} from {max}</Typography>
    </Box>
  );
}